import { post } from 'helpers/api';
import { useOneOffSubscription } from 'helpers/action_cable/use_one_off_subscription';

type Frame =
  | { type: 'delta'; text: string; seq: number }
  | { type: 'done'; text: string; chatId: number }
  | { type: 'error'; error: true };

interface Options {
  chatId?: number;
  context: Record<string, unknown>;
  currentText: string;
  feature: string;
  format: 'html' | 'text';
  instruction: string;
  subscribe: ReturnType<typeof useOneOffSubscription>['subscribe'];
  onDelta: (text: string) => void;
  onDone: (text: string, chatId: number) => void;
  onError: () => void;
}

export function streamGeneration({
  chatId,
  context,
  currentText,
  feature,
  format,
  instruction,
  subscribe,
  onDelta,
  onDone,
  onError,
}: Options) {
  let streamed = '';

  subscribe<Frame>(
    {
      async connected(requestId) {
        await post('/ai/generate_text', {
          chatId, context, currentText, feature, instruction, requestId, textFormat: format,
        });
      },
      connectedError: onError,
      rejected: onError,
      received(frame) {
        if (frame.type === 'error') {
          onError();
          return;
        }

        if (frame.type === 'done') {
          onDone(frame.text, frame.chatId);
          return;
        }

        streamed += frame.text;
        onDelta(streamed);
      },
    },
    { isTerminal: frame => frame.type === 'done' || frame.type === 'error' }
  );
}
